import type { Provider as ProviderInstance } from 'src/shared/stores/resource';

export function patientsQueryParamsForUser(user: ProviderInstance | null) {
  return user?.teamRolePropertyName ? { [user.teamRolePropertyName]: user.id } : {};
}

export function myPebblesQueryParams(user: ProviderInstance) {
  return { assignee: user.id, status: ['new', 'acknowledged', 'on_hold', 'in_progress'] };
}
